import { IStageConfig } from './interfaces/main';
import { defaults } from './stages/default';

export const stageConfigs: { [key: string]: IStageConfig } = {
  default: defaults
};
